module.exports = __webpack_public_path__ + "img/pie.12317c69.jpg";